import axios from 'axios'

import { PRODUCTREVIEW as ENDPOINT } from '../common/endpoints'
import { success, error } from '../main/toast-notifications'
import { t } from '../main/i18n'
import { createLightbox } from '../main/lightbox'

const targetClass = '.j-product-review'
const targetBtn = document.querySelector('.j-open-product-review')
const lightbox = document.querySelector(targetClass)
const reviewForm = lightbox.querySelector('form')
let lightboxInstance

const bindEvents = (reviewForm) => {
	reviewForm.addEventListener('submit', getToken)
}

const removeEvents = (reviewForm) => {
	reviewForm.removeEventListener('submit', getToken)
}

const getToken = (evt) => {
	evt.preventDefault()
	grecaptcha.ready(function() {
		grecaptcha.execute('6Ldtk0gfAAAAACPWMoSiKjmoEZ68JbjcdCT9Vqo-', {action: 'submit'}).then(function(token) {

			const tokenField = document.querySelector('.g-recaptcha-token')
			tokenField.value = token
			handleSubmit(evt)

		})
	})
}

const handleSubmit = async (e) => {
	e.preventDefault()
	const tokenField = document.querySelector('.g-recaptcha-token')
	const {
		['review-stars']: ReviewStars,
		['review-name']: ReviewName,
		['review-lastname']: ReviewLastname,
		['review-email']: ReviewEmail,
		['review-title']: ReviewTitle,
		['review-text']: ReviewText
	} = e.target
	const Product = window.motostorm?.product || {}
	const Lang = window.motostorm?.lang

	try {
		const res = await axios.post(ENDPOINT, {
			data: {
				...Product,
				Lang,
				ReviewStars: ReviewStars.value,
				ReviewName: ReviewName.value,
				ReviewLastname: ReviewLastname.value,
				ReviewEmail: ReviewEmail.value,
				ReviewTitle: ReviewTitle.value,
				ReviewText: ReviewText.value,
				ReviewToken: tokenField.value
			},
		})
		success(t('review-success'))
		// update form content
		// updateReviewForm(res.data)
		// and/or automatically close the lightbox
		lightboxInstance.close()
	} catch (err) {
		console.error(`${err.name}: ${err.message}`)
		error(t('review-error'))
		if (res?.data) {
			updateReviewForm(res.data)
		}
	}
}

const updateReviewForm = (data) => {
	const lightboxContent = lightboxInstance.element()
	const currentFragment = lightboxContent.querySelector('.c-lightbox__body')
	// create a new fragment and attach events
	const newFragment = document.createElement('template')
	newFragment.innerHTML = data
	bindEvents(newFragment)
	// remove events from current fragment
	removeEvents(currentFragment)
	// clear old content
	currentFragment.innerHTML = ''
	// insert fragment into DOM
	currentFragment.appendChild(newFragment.content)
}

const init = () => {
	// bind events before the lightbox is removed from DOM
	if (targetBtn && lightbox) {
		bindEvents(reviewForm)
		lightboxInstance = createLightbox(targetBtn, targetClass)
	}
}

init();
